export const FREEFORM_PRESENCE_LABEL = "Here (no pin)";

const MIN_FREEFORM_NOTE_LENGTH = 5;
const MAX_FREEFORM_NOTE_LENGTH = 1_000;

/**
 * Validate the note required when presence is not linked to a checkpoint pin.
 * The server remains authoritative and applies its secret-shape guard.
 */
export function validateFreeformPresenceNote(note: string): string | null {
  const trimmed = note.trim();
  if (!trimmed) {
    return "A note is required when checking in without a checkpoint pin.";
  }
  if (trimmed.length < MIN_FREEFORM_NOTE_LENGTH) {
    return "Note is too short. Please describe why you are checking in here.";
  }
  if (trimmed.length > MAX_FREEFORM_NOTE_LENGTH) {
    return "Note must be 1,000 characters or fewer.";
  }
  return null;
}

export interface FreeformPresenceOptionPresentation {
  readonly canSelect: boolean;
  readonly helper: string;
  readonly label: typeof FREEFORM_PRESENCE_LABEL;
  readonly noteError: string | null;
  readonly visible: boolean;
}

export function getFreeformPresenceOptionPresentation({
  featureEnabled,
  note,
  presenceKind,
}: {
  readonly featureEnabled: boolean;
  readonly note: string;
  readonly presenceKind: "manual" | "adhoc";
}): FreeformPresenceOptionPresentation {
  const noteError = validateFreeformPresenceNote(note);
  return {
    canSelect: featureEnabled && noteError === null,
    helper:
      presenceKind === "manual"
        ? "Current GPS location, no checkpoint pin. Required note. Flagged for supervisor review."
        : "Current GPS location, no checkpoint pin. Required note. Lower-assurance site presence.",
    label: FREEFORM_PRESENCE_LABEL,
    noteError,
    visible: featureEnabled,
  };
}
